import LockIcon from '../../assets/images/lock.svg';
import errorIcon from '../../assets/images/lock-red.svg';
interface OptimizationLockProps {
  doNotOptimize: boolean;
  errorMessage?: string;
  // eslint-disable-next-line
  onChange?: (value: boolean) => void;
}
export default function OptimizationLock({ doNotOptimize, errorMessage, onChange }: OptimizationLockProps) {
  const hasError = Boolean(errorMessage ?? '');
  return (
    <div
      className="lock-area"
      onClick={() => {
        const value = doNotOptimize;
        if (onChange) onChange(!value);
      }}
      style={{ cursor: 'pointer' }}
    >
      <img
        className={`lock${doNotOptimize ? ' locked' : ''}`}
        src={hasError ? errorIcon : LockIcon}
        width={16}
        title={errorMessage}
      />
    </div>
  );
}
